import { query, serviceQueries } from '@estee/elc-service-bus';

import { LoadLoyaltyInfoUseCase } from '~use-cases/LoadLoyaltyInfoUseCase';
import { LoyaltyEnrolledUseCase } from '~use-cases/LoyaltyEnrolledUseCase';

export class ServiceBusController {
    public isLoyaltyMember = async (): Promise<boolean> => {
        const { hasLoyalty = false } = (await query(serviceQueries.BASIC_USER_DETAILS)) || {};
        if (hasLoyalty) {
            await new LoadLoyaltyInfoUseCase().execute();
        }

        return hasLoyalty;
    };

    public enrolmentIntoLoyalty = async () => {
        await new LoyaltyEnrolledUseCase().execute();
    };
}
